import React, { useEffect } from "react";
import HappyIcon from "../../../images/happy.svg";
import { TableHead, TableRow, TableCell } from "@mui/material";
import { StyledTableCell } from "./StyledTableCell";
import { StyledTableRow } from "./StyledTableRow";

export const HeaderTable = ({ children }) => {
  const iconRef = React.useRef(null);
  const [iconWidth, setIconWidth] = React.useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIconWidth(iconRef.current.offsetWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <TableHead>
      <TableRow>
        <StyledTableCell align="center" style={styles.header}>
          <div ref={iconRef} style={{ ...styles.imageContainer }}>
            <img
              style={{
                ...styles.icon,
                width: iconWidth <= 200 ? iconWidth : 200,
                bottom: iconWidth <= 200 ? -50 : -100,
              }}
              src={HappyIcon}
              alt="HappyIcon"
            />
          </div>
        </StyledTableCell>
        <StyledTableCell align="center">Course standard</StyledTableCell>
        <StyledTableCell style={styles.title} align="center">
          Course pro
        </StyledTableCell>
      </TableRow>
    </TableHead>
  );
};

const styles = {
  icon: {
    position: "absolute",
    bottom: -100,
    width: 200,
  },
  imageContainer: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: 300,
    overflow: "hidden",
    bottom: 0,
    alignSelf: "center",
  },
  header: {
    flex: 1,
    position: "relative",
    padding: 0,
    maxHeight: 300,
    minHeight: 50,
  },
  title: {
    fontFamily: "Caprasimo",
    color: "rgba(230, 100, 0, 1)",
  },
};
